var amdi18n={"__root":{"preload_images_started":"Loading images started","preload_images_succeeded":"Loading images succeeded","preload_images_failed":"Loading images failed","cant_load_image":"Can't load image: ","preload_webfonts_started":"Loading webfonts started","preload_webfonts_succeeded":"Loading webfonts succeeded","preload_webfonts_failed":"Loading webfonts failed","timeout_occurred":"Timeout occurred"},"__de":{"preload_images_failed":"Laden der Bilder fehlgeschlagen","cant_load_image":"Bild kann nicht geladen werden: ","preload_webfonts_failed":"Laden der Web-Schriftarten fehlgeschlagen","timeout_occurred":"Zeitüberschreitung aufgetreten"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/util/nls/UiUtil_strings.js
// module id = 274
// module chunks = 6